import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import {
    BannerContainer,
    TextContainer,
    Text,
    Title,
    SubText,
} from './Banner.styled';
  

const Banner = ({
    title,
    content = '',
    subtitle,
    width = '90%',
    lineClamp,
    webWidth = '90%',
    bannerDisplay,
    clicked,
    messageType,
    renderAnnouncement,
    subtitleFontSize,
    proxyBackgroundColor,
    adminImpersonateBGColor
}) => {

    const getBannerContent = () => {
        if (content) {
            return content
                .replaceAll('&nbsp;', ' ')
                .replaceAll('&quot;', '"')
                .replaceAll('&apos;', "'")
                .replaceAll('&#39;', "'")
                .replaceAll('&amp;', '&')
                .replaceAll('<a', '<a target="_blank"');
        }
        return '';
    };
    const isDismiss = messageType === 'userInfoMessage';
    const isAnnouncement = messageType === 'announcement';
    const bannerContent = getBannerContent();

    return (
        <div className="banner-container">
            <BannerContainer
                padding={title}
                backgroundColor={isDismiss || isAnnouncement}
                bannerDisplay={bannerDisplay}
                proxyBackgroundColor={proxyBackgroundColor}
                adminImpersonateBGColor={adminImpersonateBGColor}
            >
                <TextContainer
                    flexDirection={title}
                    alignItems={title}
                    width={width}
                    webWidth={webWidth}
                >
                    {renderAnnouncement && renderAnnouncement()}
                    {title && (
                        <>
                            <Title>{title}</Title>
                            <SubText fontSize={subtitleFontSize}>
                                {subtitle}
                            </SubText>
                        </>
                    )}
                    {bannerContent && (
                        <Text lineClamp={lineClamp}>
                            {ReactHtmlParser(bannerContent)}
                        </Text>
                    )}
                </TextContainer>
                {messageType !== 'announcement' && (
                    <Button
                        id={'common-banner-button'}
                        show={true}
                        width={'90px'}
                        height={'36px'}
                        fontSize={'14px'}
                        margin={'0 5px 0 0'}
                        variant={isDismiss ? ButtonStyles?.bannerDismiss
                            : proxyBackgroundColor ? ButtonStyles?.bannerproxyBGColor
                            : adminImpersonateBGColor ? ButtonStyles?.bannerproxyAdminImpersonateBGColor : ButtonStyles?.bannerproxyAdminImpersonateBGColor
                        }
                        clicked={clicked}
                    >
                        {isDismiss ? 'Dismiss' : 'Done'}
                    </Button>
                )}
            </BannerContainer>
        </div>
    );
};

export default Banner;
